import { render } from "./discountSvg.vue?vue&type=template&id=2dc69812"
import script from "./discountSvg.vue?vue&type=script&lang=js"
export * from "./discountSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__